import { logError } from '@marketplace-web/observability/logging-util'
import { clientSideMetrics } from '@marketplace-web/observability/client-metrics-util'

import { ITEM_PAGE_PREFIX } from '../constants'

const ITEM_PAGE_LOAD_COUNT_METRIC_NAME = 'item_page_client_load_count'

export const logItemPageError = (error: Error | null, feature?: string, extra?: string) => {
  if (!(error instanceof Error)) return

  const loggedFeature = feature ? `${ITEM_PAGE_PREFIX}_${feature}` : ITEM_PAGE_PREFIX

  logError(error, { feature: loggedFeature, extra })
}

export const incrementPageLoadCounter = (state: 'succeeded' | 'failed' | 'initiated') => {
  clientSideMetrics.counter(ITEM_PAGE_LOAD_COUNT_METRIC_NAME, { state }).increment()
}
